import { render } from "./StrategyEvent.vue?vue&type=template&id=1c488533"
import script from "./StrategyEvent.vue?vue&type=script&lang=js"
export * from "./StrategyEvent.vue?vue&type=script&lang=js"

import "./StrategyEvent.vue?vue&type=style&index=0&id=1c488533&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__